import React, { useState, useEffect } from 'react';
import { routes } from 'constants/config';
import { useFetch } from 'hooks';
import Spinner from 'ui/Spinner';

const DemuxAppsIntegrationSettings = () => {
  const [apps, setApps] = useState([]);

  const { data, loading } = useFetch(routes.SETTINGS.INTEGRATIONS);

  useEffect(() => {
    if (data?.apps) {
      setApps(data.apps);
    }
  }, [loading, data, apps]);

  const IntegrationButton = ({ href, buttonText, buttonProps = {} }) => {
    if (buttonProps.type === 'button') {
      return (
        <button
          type="button"
          className="Button--customColor NewButton"
          href={href}
          {...buttonProps}
        >
          {buttonText}
        </button>
      );
    }

    return (
      <a className="Button--customColor NewButton" href={href} {...buttonProps}>
        {buttonText}
      </a>
    );
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          {apps.map((app, index) => (
            <div className="row" key={app.id} id="demux-app-integrations">
              <div className="col-md-12">
                <div className="SettingsContent-section">
                  <h3 className="SettingsContent-heading">{app.name}</h3>
                  <hr />
                  <p>{app.description}</p>
                  {app.hasExternalApp && app.connectionId && (
                    <IntegrationButton
                      href={routes.DEMUX_APPS.CONNECTIONS(app.connectionId)}
                      buttonText={t('settings.tab.integrations.configure')}
                      buttonProps={{ target: '_blank', rel: 'noreferrer' }}
                    />
                  )}
                  {app.hasExternalApp && !app.connectionId && (
                    <IntegrationButton
                      href={routes.DEMUX_APPS.CONNECTIONS_NEW(app.id)}
                      buttonText={t('settings.tab.integrations.install')}
                      buttonProps={{ target: '_blank', rel: 'noreferrer' }}
                    />
                  )}
                  {!app.hasExternalApp && app.connectionId && (
                    <IntegrationButton
                      href={routes.DEMUX_APPS.CONNECTIONS(app.connectionId)}
                      buttonText={t('settings.tab.integrations.enabled')}
                      buttonProps={{
                        target: '_blank',
                        rel: 'noreferrer',
                        type: 'button',
                        disabled: true,
                      }}
                    />
                  )}
                  {!app.hasExternalApp && !app.connectionId && (
                    <IntegrationButton
                      href={routes.DEMUX_APPS.CONNECTIONS_NEW(app.id)}
                      buttonText={t('settings.tab.integrations.install')}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default DemuxAppsIntegrationSettings;
